/*eslint-disable */
const $ = window.jQuery = require('jquery');

import addPaperpile from './add-paperfiles';
import axios from 'axios';
import {
  bus
} from '@/main';
import {
mapGetters,
} from 'vuex';
import noteReadView from './paper-note-read-view';
import paperCitationPopup from './paper-citation-popup';
import paperMoveToFolder from './paper-move-to-folder';
import paperSharedToUser from './paper-share-with-user-popup';
import pdfViewer from './pdf-viewer';
import toast from '@/services/toast';
import trashPaperPopup from './trash-paper-popup';
import updatePpDetails from './update-paperpile-details';

export default {
  name: 'paperpiles',
  components: {
    'add-paperpile' : addPaperpile,
    'pdf-viewer' : pdfViewer,
    'update-pp-details' : updatePpDetails,
    'paper-move-to-folder':paperMoveToFolder,
    'note-read-view' : noteReadView,
    'trash-paper-popup':trashPaperPopup,
    'paper-share':paperSharedToUser,
    'paper-citation-popup' : paperCitationPopup
  },
  props: [],
  data () {
    return {
      addPaperPilePopupState:false,
      paperPileDetails:null,
      paperPileResults:[],
      nextPageUrl:'',
      nextSteper:'',
      userLoading:false,
      pdf_is_fav:Boolean,
      pdfViewerPopup:false,
      pdfViewerUrl:'',
      pdfId:'',
      pdfViewerFileName:'',
      updatePaperPileDetailPopupState:false,
      search_term:'',
      normalPaperPileListState:true,
      searchPaperPileListState:false,
      searchPaperPileData:null,
      searchPaperPileList:[],
      paperMoverToFolder:false,
      paperMoverToFolderData:null,
      notesViewData:null,
      notesViewPopupState:false,
      paperUpdateInfo:null,
      paperSelected:'',
      trashPaperState:false,
      trashPaperId:'',
      sharedPaperState:false,
      sharedPaperInfo:null,
      sharedPaperResultData:null,
      sharedPaperResultList:[],
      selfUserInfo:null,
      citationPopupState:false,
      citationPaperId:''
    }
  },
  computed: {
    ...mapGetters([
      'getPaperPileListGetters',
      'getSharedPaperListGetters',
      'acUserDetailsStateGetters',
    ]),
    getSelfUserDetailsFun(){
      this.selfUserInfo = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
    getPaperPileDetails(){
      this.paperPileDetails = this.$store.getters.getPaperPileListGetters.data;
      return
    },
    getPaperPileResultsIntialsState(){
      if(this.paperPileDetails){
        this.nextPageUrl = this.paperPileDetails.next
        this.nextSteper = this.paperPileDetails.next
        this.paperPileResults = [].concat(this.paperPileDetails.results)
      }
    },
    getSharedPaperDetail(){
      this.sharedPaperResultData = this.$store.getters.getSharedPaperListGetters.data;
      return
    },
    getSharedPaperResultsIntialsState(){
      if(this.sharedPaperResultData){
        this.sharedPaperResultList = [].concat(this.sharedPaperResultData.results)
      }
    }
  },
  mounted () {
    this.getSelfUserDetailsFun
    bus.$on('addPaperPilePopupStateBus', (data) => {
      this.addPaperPilePopupState = data;
    });
    bus.$on('pdfViewerPopupBus', (data) => {
      this.pdfViewerPopup = data;
    });
    bus.$on('updatePaperPileDetailPopupStateBus', (data) => {
      this.updatePaperPileDetailPopupState = data;
    });
    bus.$on('paperMoverToFolderBus', (data) => {
      this.paperMoverToFolder = data;
    });
    bus.$on('notesViewPopupStateBus', (data) => {
      this.notesViewPopupState = data;
    });
    bus.$on('paperSelectedBus', (data) => {
      this.paperSelected = data;
    });
    bus.$on('trashPaperStateBus', (data) => {
      this.trashPaperState = data;
    });
    bus.$on('sharedPaperBus', (data) => {
      this.sharedPaperState = data;
    });
    bus.$on('paperCitationPopupStateBus', (data) => {
      this.citationPopupState = data;
    });
  },
  methods: {
    citationPopupOpenMethod(Id){
      this.citationPaperId = Id
      this.citationPopupState = true
      $('body').addClass('body_right_scroll_remove')
    },
    paperSharedMethod(data){
      this.sharedPaperInfo = data
      this.sharedPaperState = true
      $('body').addClass('body_right_scroll_remove')
    },
    trashPaperMethod(ID){
      this.trashPaperId = ID
      this.trashPaperState = true
      $('body').addClass('body_right_scroll_remove')
    },
    noteViewShowMethod(data){
      this.notesViewData = data
      this.notesViewPopupState = true
      $('body').addClass('body_right_scroll_remove')
    },
    paperMoverToFolderMethod(data){
      this.paperMoverToFolderData = data
      this.paperMoverToFolder = true
      $('body').addClass('body_right_scroll_remove')
    },
    getPaperPileListAgain(){
      this.$store.dispatch('getAllPaperPileFun')
    },
    showLoadMoreDataFun(url) {
      this.userLoading = true
      axios.get(url).then((response) => {
          this.nextSteper = response.data.data.next
          this.paperPileResults = [].concat(this.paperPileResults,response.data.data.results);
          this.userLoading = false
        });
    },
    openPopupOfAddPaperPile(){
      this.addPaperPilePopupState = true
      $('body').addClass('body_right_scroll_remove')
    },
    updatePpDetailMethod(data){
      this.paperUpdateInfo = data
      this.updatePaperPileDetailPopupState = true
      $('body').addClass('body_right_scroll_remove')  
    },
    favOfPaperMethod(isFav, paperId){
      if(isFav == true){
        this.pdf_is_fav = false
      }else{
        this.pdf_is_fav = true
      }
      let data = {
        is_favourite : this.pdf_is_fav
      }
      this.$store.dispatch('updatePaperPileDetailsByIdFun', {data:{id:paperId,data:data}})
        .then((res) => {  
          toast.success(res.data.msg);
          this.getPaperPileListAgain()
        }).catch((err) => {
          toast.error(err.data.user_msg || err.data.msg);
      })
    },
    pdfViewerFun(url, fileName, Id){
      this.pdfId = Id
      this.pdfViewerFileName = fileName
      this.pdfViewerUrl = url
      this.pdfViewerPopup = true
      $('body').addClass("pdf_view_actv")
    },
    validateSearchModelsBeforeSubmit(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          if(this.search_term.length >= 3){
            this.normalPaperPileListState = false
            this.searchPaperPileListState = true
            this.$store.dispatch('searchPaperPileFun', { search_term: this.search_term }).then((response) => {
              this.searchPaperPileData = response.data
              this.searchPaperPileList = this.searchPaperPileData.data
            })
          }else{
            this.searchPaperPileListState = false
            this.normalPaperPileListState = true
            this.searchPaperPileList = []
          }
        }
      })
    },
  },
  watch:{
    getPaperPileDetails(){
      return this.$store.getters.getPaperPileListGetters;
    },
    getPaperPileResultsIntialsState(){
      if(this.paperPileDetails != undefined){
        this.nextPageUrl = this.paperPileDetails.next
        this.paperPileResults = [].concat(this.paperPileDetails.results)
      }
    },
    nextSteper(old_val, new_val){
      if(old_val != ''){
        this.nextPageUrl = old_val
      }
    },
    getSharedPaperDetail(){
      return this.$store.getters.getSharedPaperListGetters
    },
    getSharedPaperResultsIntialsState(){
      if(this.sharedPaperResultData){
        this.sharedPaperResultList = [].concat(this.sharedPaperResultData.results)
      }
    },
    getSelfUserDetailsFun(){
      return this.$store.getters.acUserDetailsStateGetters;
    },
  },
  beforeCreate:function(){
    $('body').addClass('researchfile_body_wrp')
  },
  beforeRouteLeave: function(to, from, next) {
    if(to.name != 'awerackResearchGroup' && to.name != 'paperPilesPreferences'  && to.name != 'bucketDetails'){
      $('body').removeClass('researchfile_body_wrp');
    }
    next();
  },
}